import Index from './index'
import Listar from './Listar'
import Integracao from './Integracao'
import Novo from './Novo'
import Detalhes from './Detalhes'

const route = {
  path: '/campanhas',
  name: 'campanhas',
  component: Index,
  children: [
    { path: 'listar', name: 'campanhas-listar', component: Listar },
    { path: 'integracao', name: 'integracao-listar', component: Integracao },
    { path: 'novo', name: 'campanhas-novo', component: Novo },
    { path: ':id', name: 'campanhas-detalhe', component: Detalhes, props: true },
    { path: ':id/e', name: 'campanhas-editar', component: Novo, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/campanhas/routes.js